module.exports = __webpack_public_path__ + "static/dance-f42a14f7e6f5ca0b2ac2ba659ca61598.jpg";